import styled from "styled-components";
import { colors } from "../../../../../libs";

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 62px;
  background-color: ${colors.background.lightBlack};
  padding: 20px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  position: sticky;
  top: 0px;
  z-index: 1;
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
`;

export const BackText = styled.span`
  margin-left: 10px;
  font-size: 14px;
  color: #858585;
  cursor: pointer;
`;

export const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 20px; 
`;

export const CloseIconImage = styled.img`
  width: 18px; 
  height: 18px;
`;

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  color: ${colors.text.white};
  font-size: 18px;
  cursor: pointer;
`;


